import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../shared/shared.module';

import { ToolRequestComponent } from './pages/tool-request/tool-request.component';
import { ToolGroupRequestComponent } from './pages/tool-request/tool-group-request/tool-group-request.component';
import { ToolIndividualRequestComponent } from './pages/tool-request/tool-individual-request/tool-individual-request.component';
import { ToolRequestsService } from "@services/tool-requests.service";
import { SearchLineAndRequestComponent } from './pages/tool-return/components/search-line-and-request.component';
import { ToolReturnComponent } from "@app/roles/line-setter/pages/tool-return/tool-return.component";
import { ComponentsModule } from "@components/components.module";
import { ToolModule } from "@app/tool/tool.module";
import { PendingToolReturnsComponent } from './pages/pending-tool-returns/pending-tool-returns.component';
import { ToolReturnsService } from "@services/tool-returns.service";
import { SignalIssueComponent } from "@app/roles/line-setter/pages/signal-issue/signal-issue.component";
import {
    SignalIssueFormComponent
} from "@app/roles/line-setter/pages/signal-issue/components/signal-issue-form/signal-issue-form.component";
import { TableModule } from "@components/custom-table/table.module";
import { PendingToolRequestsComponent } from './pages/pending-tool-requests/pending-tool-requests.component';
import {
    PendingToolRequestsTableComponent
} from "@app/roles/line-setter/pages/pending-tool-requests/components";
import { IssuesService } from "@services/issues.service";
import { ToolReturnForMaintenanceComponent } from './pages/tool-return-for-maintenance/tool-return-for-maintenance.component';
import { PendingToolReturnsTableComponent } from "@app/roles/line-setter/pages/pending-tool-returns/components";
import {
    ToolAtErsaConfirmationModalComponent
} from './pages/tool-return/components/tool-ersa-confirmation-modal/tool-ersa-confirmation-modal.component';

@NgModule({
    declarations: [
        ToolRequestComponent,
        ToolGroupRequestComponent,
        ToolIndividualRequestComponent,
        SignalIssueComponent,
        SignalIssueFormComponent,
        ToolReturnComponent,
        PendingToolReturnsComponent,
        PendingToolReturnsTableComponent,
        PendingToolRequestsComponent,
        PendingToolRequestsTableComponent,
        ToolReturnForMaintenanceComponent,
        SearchLineAndRequestComponent,
        ToolAtErsaConfirmationModalComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        SharedModule,
        ToolModule,
        TableModule,
    ],
    providers: [
        IssuesService,
        ToolReturnsService,
        ToolRequestsService
    ],
    bootstrap: []
})
export class LineSetterModule {
}
